
<!-- SIDENAV CONTENT -->
<div class="sidenav-content" fusePerfectScrollbar fxFlex>

    <!-- CHATS CONTENT -->
    <div *fuseIfOnDom [@animateStagger]="{value:'50'}">

        <!-- CONTACTS LIST-->
        <div class="contact-list" fxLayout="column">

            <div matSubheader *ngIf="(contacts | filter: searchText).length > 0">
                Contacts
            </div>

            <button mat-button class="contact"
                    *ngFor="let contact of contacts| filter: searchText"
                    (click)="getChat(contact.id)"
                    [@animate]="{value:'*',params:{y:'100%'}}">

                <div fxLayout="row" fxLayoutAlign="start center">

                    <div class="avatar-wrapper" fxFlex="0 1 auto">
                        <img src="{{contact.avatar}}" class="mat-avatar avatar" alt="{{contact.name}}"/>
                        <mat-icon class="s-16 status" [ngClass]="contact.status"></mat-icon>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="start start">
                        <div class="contact-name">{{contact.name}}</div>
                        <p class="contact-mood">{{contact.mood}}</p>
                    </div>

                </div>

            </button>

        </div>
        <!-- / CONTACTS LIST-->

        <!-- NO RESULTS MESSAGE -->
        <div *ngIf="(contacts | filter: searchText).length === 0" class="no-results-message">
            No results..
        </div>
        <!-- NO RESULTS MESSAGE-->

    </div>
    <!-- / CHATS CONTENT -->

</div>
<!-- / SIDENAV CONTENT -->
